import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPresentation, refreshPresentation, refreshPresentationWithQuickPickTags, downloadPresentation } from '../../actions/presentationActions';
import { getQuery, setGlobal, setCurrentQPs } from '../../actions/queryActions';
import { getQPDataSource, getDataSource } from '../../actions/databaseActions';
import { showPopup } from '../../actions/uiActions';
import Sheets from '../../components/main/Sheets';

function SheetsContainer(props) {
    let navigate = useNavigate();
    let location = useLocation();
    let params = useParams();

    // State objects that control the page
    let [sheet, setSheet] = useState(null);
    let [sheetBegin, setSheetBegin] = useState(null);
    let [sheetEnd, setSheetEnd] = useState(null);
    let [flag, setFlag] = useState(false);

    // trigger on component mount
    useEffect(() => {
        if (Object.keys(props.presentationView).length === 0 && !props.showError && !props.singlePresentationCheck) {
            props.getPresentation(params.id)
        }

        if (props.presentationView !== null && props.presentationView.sheets !== undefined) {
            setSheetBegin(1);
            setSheetEnd(props.presentationView.sheets.length);
        }

        if (!flag && props.presentationView.sheets && props.presentationView.sheets[0].sheetImage) {
            if (location.pathname.includes("sheets") && props.presentationView.sheets) {
                viewSheet(location.pathname.split('/')[5]);
            } else {
                viewSheet("1");
            }
            setFlag(true);
        }
    });

    function showQuickPickEditor(qpId) {
        if (props.qpDataSource === null) {
            props.getQPDataSource(props.presentationView.connectionInfos[0].id, 1, "qpPopup", null, false, qpId);
        } else {
            props.showPopup("qpPopup");
        }
        props.setCurrentQPs(props.presentationView.quickPicks);
    }

    function showGlobalEditor(globalID) {
        props.setGlobal(props.presentationView.globals.find(x => x.id === parseFloat(globalID)));
        navigate(`/presentations/excel/${this.props.presentationView.presentationID}/globals/${globalID}`);
    }

    function viewSheet(index) {
        navigate(`/presentations/excel/${props.presentationView.presentationID}/sheets/${index}`, { replace: true });
        setSheet(props.presentationView.sheets.find(x => x.sheetIndex === parseFloat(index)));
    }

    function openQuery(id) {
        props.getQuery(id);
        navigate(`/queries/${id}`);
    }

    function handleRefreshPresentation(id, connId, globals, editQuickPickIDs, quickPickAliases) {
        props.refreshPresentation(id, 1, connId, [], editQuickPickIDs, quickPickAliases);
        navigate('/presentations');
    }

    function handleRefreshPresentationWithQuickPickTags(id, globals, quickPickTags) {
        props.refreshPresentationWithQuickPickTags(id, globals, quickPickTags);
        navigate('/presentations');
    }

    if (location.pathname.includes("download") && Object.keys(props.presentationView).length > 0 && !props.downloadCheck) {
        props.downloadPresentation(props.presentationView.presentationID, props.presentationView.presentation.name + ".xlsx");
    }

    return <Sheets
        presentationView={props.presentationView}
        getPresentation={props.getPresentation}
        sheet={sheet}
        viewSheet={viewSheet}
        {...props}
        openQuery={openQuery}
        handleRefreshPresentation={handleRefreshPresentation}
        handleRefreshPresentationWithQuickPickTags={handleRefreshPresentationWithQuickPickTags}
        sheetBegin={sheetBegin}
        sheetEnd={sheetEnd}
        getQPDataSource={props.getQPDataSource}
        showGlobalEditor={showGlobalEditor}
        showQuickPickEditor={showQuickPickEditor}
        downloadPresentation={props.downloadPresentation}
        isPresentationBigLoaded={props.isPresentationBigLoaded} />;
}


function mapStateToProps(state) {
    return {
        presentationView: state.presentations.present.presentationView,
        showError: state.ui.showError,
        currentDataSource: state.databases.currentDataSource,
        modifiedGlobals: state.queries.present.modifiedGlobals,
        modifiedQPs: state.queries.present.modifiedQPs,
        downloadCheck: state.presentations.present.downloadCheck,
        singlePresentationCheck: state.presentations.present.singlePresentationCheck,
        qpDataSource: state.databases.qpDataSource,
        isPresentationBigLoaded: state.presentations.present.isPresentationBigLoaded,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(
            {
                getPresentation,
                getQuery,
                refreshPresentation,
                refreshPresentationWithQuickPickTags,
                getQPDataSource,
                getDataSource,
                setGlobal,
                setCurrentQPs,
                downloadPresentation,
                showPopup,
            }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SheetsContainer)